var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import InputDataProcessor from './input-data-processor';
/**
 * Use when fetching caseDetails and when fetching action modal
 */
export var parseTemplateWithData = function (caseData, caseTemplate, i18n) {
    var _a, _b;
    var RESOLVERS = {};
    // Only merge if we are explicitly in a V5 middleOffice context
    var moLinksV5 = (_b = (_a = caseData === null || caseData === void 0 ? void 0 : caseData._embedded) === null || _a === void 0 ? void 0 : _a.middleOffice) === null || _b === void 0 ? void 0 : _b._links;
    var enhancedCaseData = moLinksV5
        ? __assign(__assign({}, caseData), { _links: __assign(__assign({}, caseData._links), moLinksV5) }) : caseData;
    RESOLVERS['template'] = InputDataProcessor.TemplateResolver(RESOLVERS);
    RESOLVERS['resourceData'] = InputDataProcessor.ResourceDataResolver(RESOLVERS, enhancedCaseData);
    return InputDataProcessor.deepResolveObject(__assign({}, caseTemplate), [], RESOLVERS, i18n);
};
